import React from "react";
//Helpers
import styled from "styled-components";
import PropTypes from "prop-types";
import { AnimatedBackground, Icon } from "../../atoms";
import { ContentContainerMolecule } from "../../molecules";

const Mask = props => {
  return (
    <ContentContainerMolecule backgroundColor="#fff" position="absolute" {...props} />
  );
};

const LoadingCard = () => {
  return (
    <ContentContainerMolecule height="105px" backgroundColor="#fff">
      <div className="container">
        <div className="triangle">&nbsp;</div>
        <AnimatedBackground height="105px">
          <Mask height="20px" right="0" width="100%" />
          <Mask height="20px" top="20px" right="0" width="85%" />
          <Mask height="15px" top="40px" width="100%" />
          <Mask height="30px" top="55px" right="0" width="70%" />
          <Mask height="20px" top="85px" right="0" width="100%" />
        </AnimatedBackground>
      </div>
    </ContentContainerMolecule>
  );
};

const Loading = ({ className }) => {
  return (
    <div className={className}>
      <div className="container">
        <div className="row justify-content-center align-items-center">
          <div className="col-auto">
            <Icon name="fas fa-image" color="#dddddd" fontSize="32px" />
          </div>
        </div>
      </div>
      <LoadingCard />
    </div>
  );
};

Loading.propTypes = {
  className: PropTypes.string
};

const LoadingWithStyles = styled(Loading)`
  /*height: ${window.innerHeight - (105 + 40 + 50) + "px"};*/
  //max-height: 992px;
  //min-height: 576px;
  height: calc(100vh - (40px + 105px + 50px));
  background-color: #f6f7f8;
  .row {
    /*height: ${window.innerHeight - (105 + 40 + 50 + 105) + "px"};*/
    //max-height: calc(992px - 105px);
    //min-height: calc(576px - 105px);
    height: calc(100vh - (40px + 105px + 50px + 105px));
  }
  .container {
    position: relative;
  }
  .triangle {
    width: 60px;
    height: 60px;
    position: absolute;
    right: 25px;
    background-color: #fff;
    top: -30px;
    z-index: 2;
    transform: rotate(45deg);
  }
  // Medium devices (tablets, less than 992px)
  @media (max-width: 991px) {
    /*height: ${window.innerHeight - (85 + 40 + 25) + "px"};*/
    height: calc(100vh - (40px + 85px + 25px));
    .row {
      /*height: ${window.innerHeight - (85 + 40 + 25 + 105) + "px"};*/
      height: calc(100vh - (40px + 85px + 25px + 105px));
    }
  }
`;

export default LoadingWithStyles;
